const createMap = require('./createClass/createMap');
const createChainable = require('./createClass/createChainable');

module.exports = createMap(createChainable(Object));
